@if (label && appearance === 'outline') {
  <label class="header-datepicker-label" (click)="toggleDropdown($event)">{{ label }}</label>
}
<div class="header-datepicker-container" [class.disabled]="disabled" [class.outline]="appearance === 'outline'" (click)="toggleDropdown($event)">
  @if (icon) {
    <div class="datepicker-icon">
      <tidy-image [src]="icon" />
    </div>
  }
  <span class="header-datepicker-value">{{ getDisplayValue() }}</span>
  <div class="select-arrow" [class.open]="isOpen">
    <tidy-image [src]="'assets/svg/chevron-down-white.svg'" />
  </div>
</div>
@if (isOpen) {
  <div class="header-datepicker-dropdown">
    @if (!showCustomDatePicker) {
      <div class="header-datepicker-dropdown-list">
        @for (option of selectOptions; track option.value) {
          <div
            class="header-datepicker-dropdown-item"
            [class.selected]="option.value === rangeOption"
            (click)="selectOption(option, $event)">
            <tidy-text [body]="option.viewValue" />
          </div>
        }
      </div>
    }
    @if (showCustomDatePicker) {
      <div class="custom-date-picker">
        <div class="custom-date-header">
          <tidy-text [body]="'Custom Date Range'" />
        </div>
        <div class="custom-date-inputs">
          <div class="date-input-group">
            <label class="date-label">Start Date</label>
            <input
              #startDateInput
              type="date"
              class="date-input"
              [(ngModel)]="tempStartDate"
              (click)="$event.stopPropagation()" />
          </div>
          <div class="date-input-group">
            <label class="date-label">End Date</label>
            <input
              #endDateInput
              type="date"
              class="date-input"
              [(ngModel)]="tempEndDate"
              [min]="tempStartDate"
              (click)="$event.stopPropagation()" />
          </div>
        </div>
        <div class="custom-date-actions">
          <button class="action-button cancel" (click)="cancelCustomDate($event)">Cancel</button>
          <button
            class="action-button apply"
            [disabled]="!tempStartDate || !tempEndDate"
            (click)="applyCustomDate($event)">Apply</button>
        </div>
      </div>
    }
  </div>
}
